document.addEventListener("DOMContentLoaded", () => {
  const isDesktopHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!isDesktopHover) return;

  console.log("✅ menu-hover-delay.js loaded (dt-sc)");

  const OPEN_DELAY = 250;  // increase to 400 if you want more delay
  const CLOSE_DELAY = 350; // increase to 600 if it still closes too fast

  const triggers = document.querySelectorAll("a.dt-sc-nav-link.dropdown");

  triggers.forEach((trigger) => {
    // Usually the <li> or wrapper is the parent of the <a>
    const item =
      trigger.closest("li") ||
      trigger.closest(".dt-sc-nav-item") ||
      trigger.parentElement;

    if (!item) return;

    // Try common submenu selectors for dt-sc themes
    const submenu =
      item.querySelector(".dt-sc-dropdown-menu") ||
      item.querySelector(".dt-sc-sub-menu") ||
      item.querySelector("ul");

    if (!submenu) return;

    let openTimer = null;
    let closeTimer = null;

    const show = () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => {
        item.classList.add("dt-delayed-open");
        submenu.style.display = "block";
        submenu.style.visibility = "visible";
        submenu.style.opacity = "1";
        submenu.style.pointerEvents = "auto";
      }, OPEN_DELAY);
    };

    const hide = () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        item.classList.remove("dt-delayed-open");
        submenu.style.opacity = "0";
        submenu.style.visibility = "hidden";
        submenu.style.pointerEvents = "none";
        // keep display block a bit so transition can happen
        setTimeout(() => {
          if (!item.classList.contains("dt-delayed-open")) {
            submenu.style.display = "none";
          }
        }, 200);
      }, CLOSE_DELAY);
    };

    // IMPORTANT: bind to BOTH item and submenu so moving mouse into submenu doesn't close it
    item.addEventListener("mouseenter", show);
    item.addEventListener("mouseleave", hide);
    submenu.addEventListener("mouseenter", () => clearTimeout(closeTimer));
    submenu.addEventListener("mouseleave", hide);
  });
});
